import React, { useState } from "react"
import styled from "@emotion/styled"
import BoxButton from "../NewBoxButton/NewBoxButton"

// A collapsible section header that matches the Settings look. Its open state
// uses `max-height: none` (see SectionContent) so tall content — long lists, an
// expanded editor, a help panel — is never clipped.
// Horizontal inset applied to a nested sub-section (header + content) so it
// reads as indented inside its parent section.
const NESTED_X_PADDING = "20px"

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => (props.nested ? `12px ${NESTED_X_PADDING}` : "16px 0")};
  margin-top: ${(props) => (props.nested ? "8px" : "0")};
  border-top: ${(props) => (props.nested ? "1px solid #edf2f7" : "none")};
  cursor: pointer;
`

const SectionTitleText = styled.div`
  font-size: ${(props) => (props.nested ? "14px" : "16px")};
  font-weight: ${(props) => (props.nested ? 500 : "normal")};
  color: ${(props) => (props.nested ? "#4a5568" : "#2d3748")};
`

const SectionContent = styled.div`
  overflow: ${(props) => (props.isOpen ? "visible" : "hidden")};
  max-height: ${(props) => (props.isOpen ? "none" : "0")};
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  padding: ${(props) => (props.nested ? `0 ${NESTED_X_PADDING}` : "0")};
  transition: opacity 0.2s ease-in-out;
`

// `nested` renders a subordinate sub-section (smaller title, divider above) for
// use inside another CollapsibleSection.
const CollapsibleSection = ({
  title, defaultOpen = false, nested = false, children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <>
      <SectionHeader nested={nested} onClick={() => setIsOpen((v) => !v)}>
        <SectionTitleText nested={nested}>{title}</SectionTitleText>
        <BoxButton icon={isOpen ? "chevron-down" : "chevron-right"} borderless />
      </SectionHeader>
      <SectionContent isOpen={isOpen} nested={nested}>{isOpen && children}</SectionContent>
    </>
  )
}

export default CollapsibleSection
